import React from "react"
import PropTypes from "prop-types"

const Website = ({ fillColor }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke={fillColor}
      strokeWidth="2"
      d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"
    />
  </svg>
)

Website.propsTypes = {
  fillColor: PropTypes.string,
}

Website.defaultProps = {
  fillColor: "currentColor",
}

export { Website }
